export const TicketTypeListColumns = [
  {
    Header: 'Ticket Type ID',
    accessor: 'id',
    width: 10,
  },
  {
    Header: 'Description',
    accessor: 'description',
    width: 40,
  },
]
